import { render, staticRenderFns } from "./clientData.vue?vue&type=template&id=34a8a947&scoped=true&"
import script from "./clientData.vue?vue&type=script&lang=js&"
export * from "./clientData.vue?vue&type=script&lang=js&"
import style0 from "./clientData.vue?vue&type=style&index=0&id=34a8a947&prod&lang=scss&scoped=true&"
import style1 from "./clientData.vue?vue&type=style&index=1&id=34a8a947&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a8a947",
  null
  
)

export default component.exports